"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

require("core-js/modules/es.array.concat.js");

var _i18n = require("@/assets/js/i18n");

var _Code = _interopRequireDefault(require("./components/Code"));

var _InputNumber = _interopRequireDefault(require("@/components/common/InputNumber"));

var _message = require("@/components/dialog/message");

var _qrcode = _interopRequireDefault(require("qrcode.vue"));

var _account = require("@/model/user/account");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  data: function data() {
    var accountInfo = this.$route.query.accountInfo; // if (!accountInfo) {
    //   this.$router.push({
    //     path: "/login",
    //   });
    // }

    return {
      counting: false,
      secret: "",
      appDownload: [{
        img: require("./../../assets/img/Apple-store.png"),
        apk: require("./../../assets/img/Apple-qrCode.png"),
        name: "Apple"
      }, {
        img: require("./../../assets/img/Android-market.png"),
        apk: require("./../../assets/img/Android-qrCode.png"),
        name: "Android"
      }, {
        img: require("./../../assets/img/Google-play.png"),
        apk: require("./../../assets/img/Google-qrCode.png"),
        name: "Google"
      }],
      loginLoading: false,
      // 登录loading
      currentType: "0",
      // 当前选项
      verifyData: {
        // 登录数据
        code: "",
        email: "",
        google: ""
      },
      formRules: {
        code: [{
          required: true,
          message: this.translateTitle("请输入邮箱验证码"),
          trigger: "blur"
        }, {
          pattern: /^\d{6}$/,
          message: this.translateTitle("\u9A8C\u8BC1\u7801\u5E94\u4E3A 6 \u4F4D\u6570\u5B57"),
          trigger: "blur"
        }],
        email: [{
          required: true,
          message: this.translateTitle("\u8BF7\u8F93\u5165\u90AE\u7BB1"),
          trigger: "blur"
        }, {
          pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/,
          message: this.translateTitle("\u90AE\u7BB1\u683C\u5F0F\u4E0D\u6B63\u786E"),
          trigger: "blur"
        }],
        google: [{
          required: true,
          message: this.translateTitle("\u8BF7\u8F93\u5165\u8C37\u6B4C\u9A8C\u8BC1\u7801"),
          trigger: "blur"
        }, {
          pattern: /^\d{6}$/,
          message: this.translateTitle("\u9A8C\u8BC1\u7801\u5E94\u4E3A 6 \u4F4D\u6570\u5B57"),
          trigger: "blur"
        }]
      },
      accountInfo: accountInfo
    };
  },
  mounted: function mounted() {
    this.getGoogleSecret();
  },
  computed: {
    googleCode: function googleCode() {
      if (this.accountInfo) {
        return "otpauth://totp/".concat(this.accountInfo.username, ")?issuer=Topcredit&secret=").concat(this.secret);
      } else {
        return "";
      }
    }
  },
  methods: {
    translateTitle: _i18n.translateTitle,
    onPaste: function onPaste(e) {
      var data = null;
      var clipboardData = e.clipboardData; // IE

      if (!clipboardData) {
        //chrome
        clipboardData = e.originalEvent.clipboardData;
      }

      data = clipboardData.getData("Text");
      this.verifyData.google = data;
    },
    onSendCode: function onSendCode() {
      var _this = this;

      if (!this.verifyData.email) {
        (0, _message.showMessage)({
          message: this.translateTitle("\u8BF7\u8F93\u5165\u90AE\u7BB1")
        });
        return;
      }

      var data = {
        email: this.verifyData.email
      };
      (0, _account.sendEmailCode)(data).then(function (rs) {
        if (rs.status == 200) {
          (0, _message.showMessage)({
            message: _this.translateTitle("\u53D1\u9001\u6210\u529F"),
            type: "success"
          });
          _this.counting = true;
        }
      });
    },
    // 复制成功
    copySuccess: function copySuccess() {
      (0, _message.showMessage)({
        message: this.translateTitle("\u5185\u5BB9\u590D\u5236\u6210\u529F"),
        type: "success"
      });
    },
    // 复制失败
    copyError: function copyError() {
      (0, _message.showMessage)({
        message: this.translateTitle("\u5185\u5BB9\u590D\u5236\u5931\u8D25")
      });
    },
    // 获取谷歌验证
    getGoogleSecret: function getGoogleSecret() {
      var _this2 = this;

      (0, _account.getGoogleSecretFirst)().then(function (res) {
        if (res.status === 200) {
          _this2.secret = res.data.secret;
        } else {// showMessage({ message: res.msg });
        }
      });
    },
    onVerify: function onVerify() {
      var _this3 = this;

      this.$refs.verifyForm.validate(function (valid) {
        if (valid) {
          _this3.loginLoading = true;

          if (_this3.currentType == 0) {
            var data = {
              google_secret: _this3.secret,
              google_code: _this3.verifyData.google
            };
            (0, _account.bindGoogleAuthApplication)(data).then(function (rs) {
              if (rs.status == 200) {
                _this3.handleSuccess(rs.data);

                return;
              }

              _this3.loginLoading = false;
            });
          } else {
            var _data = {
              email: _this3.verifyData.email,
              email_code: _this3.verifyData.code
            };
            (0, _account.bindEmailFrist)(_data).then(function (rs) {
              if (rs.status == 200) {
                _this3.handleSuccess(rs.data);

                return;
              }

              _this3.loginLoading = false;
            });
          }
        }
      });
    },
    handleSuccess: function handleSuccess(data) {
      var _this4 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                (0, _message.showMessage)({
                  message: _this4.translateTitle("\u767B\u5F55\u6210\u529F"),
                  type: "success"
                }); //写入cookie, 邮箱登录 , 手机登录  注册一致

                location.href = "/"; // this.$store.dispatch("getUserInfo").then((res) => {
                //   let jump = this.$route.params.jump;
                //   if (jump) {
                //     location.href = jump;
                //     return;
                //   } else {
                //   }
                // });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onTabChange: function onTabChange() {
      this.$refs.verifyForm.resetFields();
    }
  },
  components: {
    InputNumber: _InputNumber.default,
    Code: _Code.default,
    QrcodeVue: _qrcode.default
  }
};
exports.default = _default;